import cx from 'classnames'
import React from 'react'

import Icon from '@f/elements/Icon'

const StarRating = ({ backgroundType }) => (
  <span
    className={cx(
      '[ f-pos-rel f-d-inbl f-m-r-010 ] HLP-hero-rating-stars',
      backgroundType === 'light'
        ? 'f-c-fo-accent-on-light'
        : 'f-c-fo-accent-on-dark'
    )}>
    <Icon
      icon='star-filled-16px-fill'
      className='[ f-c-fi-inherit f-icon-t-body f-m-r-005 ] HLP-hero-rating-star'
    />
    <Icon
      icon='star-filled-16px-fill'
      className='[ f-c-fi-inherit f-icon-t-body f-m-r-005 ] HLP-hero-rating-star'
    />
    <Icon
      icon='star-filled-16px-fill'
      className='[ f-c-fi-inherit f-icon-t-body f-m-r-005 ] HLP-hero-rating-star'
    />
    <Icon
      icon='star-filled-16px-fill'
      className='[ f-c-fi-inherit f-icon-t-body f-m-r-005 ] HLP-hero-rating-star'
    />
    <span className='[ f-pos-rel ]'>
      <Icon
        icon='star-filled-16px-fill'
        className='[ f-c-fi-inherit f-icon-t-body f-m-r-005 ] HLP-hero-rating-star'
      />

      <span className='[ f-pos-ab f-overflow ]' style={{ left: '7px' }}>
        <Icon
          icon='star-filled-16px-fill'
          className={cx(
            '[ f-icon-t-body ] HLP-hero-rating-star HLP-hero-rating-star--empty',
            backgroundType === 'light' ? 'f-c-fi-bac025' : 'f-c-fi-pri400'
          )}
          style={{ marginLeft: '-7px' }}
        />
      </span>
    </span>
  </span>
)

export default StarRating
